// types
import type { ReadonlyHeaders } from 'next/dist/server/web/spec-extension/adapters/headers';
import type { IServiceName } from '.';

// utils
import { fetchService } from './fetch-service';

export const clusterServices: Record<string, { service: IServiceName; prefix: string }> = {
  content: {
    service: 'contentservice',
    prefix: 'content',
  },
  navigation: {
    service: 'navigationservice',
    prefix: 'navigation',
  },
  events: {
    service: 'eventservice',
    prefix: 'api/events',
  },
  info: {
    service: 'maintenanceservice',
    prefix: 'api/info',
  },
  webshop: {
    service: 'productservice',
    prefix: 'api/webshop',
  },
  catalog: {
    service: 'productservice',
    prefix: 'catalog',
  },
  categories: {
    service: 'productservice',
    prefix: '',
  },
  productpdf: {
    service: 'productservice',
    prefix: 'api/catalog',
  },
  jobs: {
    service: 'jobservice',
    prefix: 'jobs',
  },
  insights: {
    service: 'insightsservice',
    prefix: 'insights',
  },
  search: {
    service: 'elasticsearchservice',
    prefix: 'search',
  },
  suggest: {
    service: 'elasticsearchservice',
    prefix: 'suggest',
  },
  models: {
    service: 'keyvalueservice',
    prefix: 'models',
  },
  shorturls: {
    service: 'keyvalueservice',
    prefix: 'shorturls',
  },
  downloads: {
    service: 'downloadsservice',
    prefix: 'api/downloads',
  },
  form: {
    service: 'formservice',
    prefix: 'form',
  },
  mediareleases: {
    service: 'mediareleaseservice',
    prefix: 'api/mediarelease',
  },
};

export const BLACKLIST_ROUTES = [
  'downloads/cleanup',
  'form/delete',
  'crm/cleanup',
  'crm/postprocessing',
  'crm/submit',
];

const ERROR_MESSAGES = {
  blackListed: 'Access is not permitted!',
  serviceNotFound: 'Service not found',
};

export async function makeProxyRequest<T>(
  method: 'GET',
  proxy: string[],
  searchParams: URLSearchParams,
  headers: ReadonlyHeaders,
) {
  const route = Array.isArray(proxy) ? proxy.join('/') : proxy;

  if (BLACKLIST_ROUTES.some((blackListRoute) => route?.startsWith(blackListRoute))) {
    throw new Error(ERROR_MESSAGES.blackListed);
  }

  if (Array.isArray(proxy) && proxy.length && (proxy[0] && (proxy[0] in clusterServices))) {
    const { service, prefix } = clusterServices[proxy[0]]!;

    const basePath = [prefix, ...proxy.slice(1)].filter(Boolean).join('/');

    return fetchService(service, headers)
      .json(`/${basePath}?${searchParams}`, { method }) as T;
  } else {
    throw new Error(ERROR_MESSAGES.serviceNotFound);
  }
}
